<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>
    <div class="ViewPromo__section">
      <div class="ViewDieselInfo">
        <div class="ViewDieselInfo__row">
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__content">
              <h2 class="ViewDieselInfo__title">{{ name }}</h2>
              <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
              <div class="ViewDieselInfo__text app-typography">
                <h4>О компании:</h4>
                <p>
                  ООО НК-Групп, входит в группу компаний, осуществляет оптовые
                  поставки нефтепродуктов: ДТ, Бензин, Газойль, Мазут, Нефть,
                  Битум и Масла. Торговля осуществляется по внутренней
                  территории РФ и на Экспортные рынки.
                </p>
                <p>
                  Каждая партия продукции поставляется вместе с паспортом
                  качества, сертификатом соответствия ГОСТ, требованиям
                  экологической безопасности и технического регламента.
                  Гарантией качества товара служат прямые договора с
                  НПЗ-производителями: ПАО «НК РОСНЕФТЬ», «ЛУКОЙЛ», «ТАНЕКО»,
                  «ТАИФ», «ЯНОС», «Газпром».
                </p>
              </div>
            </div>
          </div>
          <div class="ViewDieselInfo__col">
            <div class="ViewDieselInfo__advantages-wrapper">
              <ul class="ViewPromo__advantages">
                <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="iphone"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">
                      Данные поставщика
                    </h4>
                    <p>
                      Телефон компании:<br />
                      <strong
                        ><a
                          href="tel:+79290069935"
                          class="ViewPromo__advantage-contact-link"
                          >+7(929)006-99-35</a
                        ></strong
                      >
                    </p>
                    <p>
                      Адрес электронной почты:<br />
                      <strong
                        ><a
                          href="mailto:nk-grupp36@bk.ru"
                          class="ViewPromo__advantage-contact-link"
                          >nk-grupp36@bk.ru</a
                        ></strong
                      >
                    </p>
                    <!-- <a
                      class="ViewPromo__advantage-link"
                      href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                      download="Реквизиты ПромРесурс.doc"
                      >Cкачать реквизиты ПромРесурс</a
                    > -->
                  </div>
                </li>
                <!-- <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                    <p>
                      ДТ Рузаевка; н/б Аэрофьюлз (Аэропорт г. Нижний
                      Новгород);<br />
                      Дельта Торг
                    </p>
                  </div>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title:
      'Топливо оптом онлайн от поставщика НТ-Групп на платформе OPEN OIL MARKET ',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1188,
    productId: 2004,
    name: 'ООО «НК-Групп»',
    inn: '3665814661',
  }),
};
</script>

<style lang="scss"></style>
